import { render, staticRenderFns } from "./tableDeleteModal.vue?vue&type=template&id=7ab052da"
import script from "./tableDeleteModal.vue?vue&type=script&lang=js"
export * from "./tableDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports